import {Multicall,ContractCallResults,ContractCallContext} from 'ethereum-bsc-multicall';
import {getTokenAbi} from '../app/tokenAbi'

const tokenAbi = getTokenAbi()
const multicall = new Multicall({
    nodeUrl: 'https://bsc-dataseed.binance.org/'
})

export const createLpContext = async (listOfLpPools:any, wallet:any) => {
    const lpCallContext: ContractCallContext<{}>[] = await listOfLpPools.map((poolAddressPair:any) => {
        return {
            reference: `${poolAddressPair[0]}`,
            contractAddress: `${poolAddressPair[1]}`,
            abi: tokenAbi,
            calls: [
                { 
                    reference: `getReserves`, 
                    methodName: 'getReserves', 
                    methodParameters: [] 
                }, 
                { 
                    reference: `getToken0`, 
                    methodName: 'token0', 
                    methodParameters: [] 
                }, 
                { 
                    reference: `getToken1`, 
                    methodName: 'token1', 
                    methodParameters: [] 
                },
                { 
                    reference: `${poolAddressPair[0]}`, 
                    methodName: 'totalSupply', 
                    methodParameters: [] 
                },
                {
                    reference: `amountInWallet`, 
                    methodName: 'balanceOf', 
                    methodParameters: [wallet] 
                }

            ]
        }
    })
    return multicall.call(lpCallContext).then(response => {
        const results: ContractCallResults = response
        return results
    })
}


